<script lang="ts">
  import { defineComponent } from "vue";
  import FicheCreditLimits from '@/generated/fiches/FicheCreditLimits.vue';
  export default defineComponent({
    extends: FicheCreditLimits,
    components: {}
})
</script>
